import {
  Box,
  Typography,
  Avatar,
  InputBase,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Badge,
  TextField,
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import { Send, Add, MoreVert } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import CustomText, { textStyles } from "../../../../components/CustomText";
import down from "../../../../assets/Messages/down.svg";
import icon1 from "../../../../assets/Messages/icon1.svg";
import pinn from "../../../../assets/Messages/pinn.svg";
import attachment from "../../../../assets/Messages/attachment.svg";
import send from "../../../../assets/Messages/send.svg";
import { useTranslation } from "react-i18next";
const Support = () => {
  const { t, i18n } = useTranslation();
  const initialChatList = useMemo(
    () => [
      {
        name: t("supportChatList.0.name"),
        msg: t("supportChatList.0.msg"),
        time: "07:29 PM",
        icon: icon1,
        pinned: false,
      },
    ],
    [t, i18n.language]
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [chatList, setChatList] = useState(initialChatList);
  const [selectedChat, setSelectedChat] = useState(initialChatList[0]);

  useEffect(() => {
    setChatList(initialChatList);
    setSelectedChat(initialChatList[0]);
  }, [initialChatList]);

  const filteredChats = chatList.filter((chat) =>
    chat?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <Box sx={{ px: 1, mt: 1 }}>
      {/* <Box sx={{ display: 'flex', height: '100vh', border: "2px solid #091E4224", borderRadius: 2, backgroundColor: "white" }}> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          height: { xs: "auto", md: "100vh" },
          border: "2px solid #091E4224",
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        {/* <Box sx={{ width: 360, borderRight: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}> */}

        <Box
          sx={{
            width: { xs: "100%", md: 380 },
            borderRight: { xs: "none", md: "1px solid #e0e0e0" },
            borderBottom: { xs: "1px solid #e0e0e0", md: "none" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "22px",
                  color: "#2C384C",
                  textAlign: "left",
                }}
              >
                {t("support.title")}
              </CustomText>
            </Box>
          </Box>

          <Divider />

          <Box sx={{ px: 1, py: 0.5 }}>
            <Box
              sx={{
                px: 0.5,
                mt: 0.5,
                py: 0.4,
                borderRadius: 1,
                height: 34,
                border: "2px solid #091E4224",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <InputBase placeholder="Search chats..." sx={{ ml: 0.5, fontSize: 15, letterSpacing: "1px", color: "#939393", fontWeight: 500 }} /> */}
              <InputBase
                placeholder={t("support.searchPlaceholder")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  ml: 0.5,
                  fontSize: 15,
                  letterSpacing: "1px",
                  color: "#939393",
                  fontWeight: 500,
                }}
              />
              <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1, overflowY: "auto", px: 1 }}>
            <List>
              {filteredChats.map((chat, index) => (
                <ListItem
                  key={index}
                  button
                  selected={selectedChat.name === chat.name}
                  onClick={() => setSelectedChat(chat)}
                  sx={{
                    px: 1,
                    position: "relative",
                    borderRadius: 2,
                    backgroundColor: "transparent",
                  }}
                >
                  <ListItemAvatar>
                    <Avatar src={chat.icon} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={chat.name}
                    secondary={chat.msg}
                    primaryTypographyProps={{
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "#100F0F",
                      fontFamily: "Poppins, sans-serif",
                    }}
                    secondaryTypographyProps={{
                      fontSize: "13px",
                      color: "#5C5C5C",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: 0.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 0,
                        color: "#100F0F",
                        fontSize: "13px",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {chat.time}
                    </Typography>
                    {chat.pinned && (
                      <img
                        src={pinn}
                        style={{ width: 20, height: 20 }}
                        alt="pinned"
                      />
                    )}
                  </Box>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>

        {/* <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}> */}
        <Box
          sx={{
            flexGrow: 1,
            width: { xs: "100%", md: "auto" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2,
              borderBottom: "1px solid #e0e0e0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar sx={{ mr: 2 }} src={selectedChat.icon} />
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "16px",
                  color: "#100F0F",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {selectedChat.name}
              </Typography>
            </Box>
            <IconButton>
              <MoreVert />
            </IconButton>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              px: 3,
              py: 2,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                color: "#2C384C",
                textAlign: "center",
                pt: 3,
                fontSize:"40px"
              }}
            >
              {t("featureUnderDevelopment")}
            </CustomText>
          </Box>

          <Divider />
          <Box sx={{ display: "flex", alignItems: "center", px: 2, py: 1 }}>
            <IconButton sx={{ color: "#44546F" }}>
              <Add sx={{ color: "#44546F" }} />
            </IconButton>
            <img src={attachment} style={{ width: 20, height: 20 }} />
            <Box sx={{ position: "relative", flexGrow: 1, mx: 2 }}>
              <input
                className="project_input"
                placeholder={t("support.typeMessagePlaceholder")}
                style={{
                  width: "100%",
                  padding: "10px 40px 10px 12px",
                  fontSize: "15px",

                  fontFamily: "Poppins, sans-serif",
                }}
              />
              <IconButton
                sx={{
                  position: "absolute",
                  right: 6,
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: 0,
                }}
              >
                <img src={send} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Support;






// import {
//   Box,
//   Typography,
//   Avatar,
//   InputBase,
//   Divider,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Badge,
//   TextField
// } from '@mui/material';
// import { useState,useMemo ,useEffect} from 'react';
// import { Send, Add, MoreVert } from '@mui/icons-material';
// import SearchIcon from '@mui/icons-material/Search';
// import CustomText, { textStyles } from "../../../../components/CustomText";
// import down from "../../../../assets/Messages/down.svg";
// import icon1 from "../../../../assets/Messages/icon1.svg";
// import icon2 from "../../../../assets/Messages/icon2.svg";
// import icon3 from "../../../../assets/Messages/icon3.svg";
// import icon4 from "../../../../assets/Messages/icon4.svg";
// import icon5 from "../../../../assets/Messages/icon5.svg";
// import icon6 from "../../../../assets/Messages/icon6.svg";
// import icon7 from "../../../../assets/Messages/icon7.svg";
// import pinn from "../../../../assets/Messages/pinn.svg";
// import attachment from "../../../../assets/Messages/attachment.svg";
// import send from "../../../../assets/Messages/send.svg";
// import { useTranslation } from "react-i18next";
// const Messages = () => {

// const { t, i18n } = useTranslation();



// const initialChatList = useMemo(() => [
//   {
//     name: t("chat_list.0.name"),
//     msg: t("chat_list.0.msg"),
//     time: "07:29 PM",
//     icon: icon1,
//     pinned: true,
//   },
//   {
//     name: t("chat_list.1.name"),
//     msg: t("chat_list.1.msg"),
//     time: "07:29 PM",
//     icon: icon2,
//   },
//   {
//     name: t("chat_list.2.name"),
//     msg: t("chat_list.2.msg"),
//     time: "12 May, 25",
//     icon: icon3,
//   },
//   {
//     name: t("chat_list.3.name"),
//     msg: t("chat_list.3.msg"),
//     time: "10 May, 25",
//     icon: icon4,
//   },
//   {
//     name: t("chat_list.4.name"),
//     msg: t("chat_list.4.msg"),
//     time: "8 May, 25",
//     icon: icon5,
//   },
//   {
//     name: t("chat_list.5.name"),
//     msg: t("chat_list.5.msg"),
//     time: "25 Mar, 25",
//     icon: icon6,
//   },
//   {
//     name: t("chat_list.6.name"),
//     msg: t("chat_list.6.msg"),
//     time: "2 Feb, 25",
//     icon: icon7,
//   }
// ], [t, i18n.language]);

//   const [searchTerm, setSearchTerm] = useState('');
//  const [chatList, setChatList] = useState(initialChatList);
// const [selectedChat, setSelectedChat] = useState(initialChatList[2]);

//   const filteredChats = chatList.filter(chat =>
//     chat.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );
//   // update when language changes
// useEffect(() => {
//   setChatList(initialChatList);
//   setSelectedChat(initialChatList[2]);
// }, [initialChatList]);
//   return (
//     <Box sx={{ px: 1,mt:1, }}>
//       <Box
//   sx={{
//     display: 'flex',
//     flexDirection: { xs: 'column', md: 'row' },
//     height: { xs: 'auto', md: '100vh' },
//     border: "2px solid #091E4224",
//     borderRadius: 2,
//     backgroundColor: "white",
//   }}
// >
  
//   <Box
//   sx={{
//     width: { xs: '100%', md: 380 },
//     borderRight: { xs: 'none', md: '1px solid #e0e0e0' },
//     borderBottom: { xs: '1px solid #e0e0e0', md: 'none' },
//     display: 'flex',
//     flexDirection: 'column',
//   }}
// >
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
//             <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
//               <CustomText sx={{ ...textStyles.h1, fontWeight: 500, fontSize: "22px", color: "#2C384C", textAlign: "left" }}>
//               {t("messages_title")}
//               </CustomText>
//               <img src={down} style={{ width:17, height: 17 }} />
//                  <Badge color="primary" badgeContent={12} sx={{ml:2,}} />
//             </Box>
         
//             <IconButton sx={{ backgroundColor: "#003149", display: "flex", justifyContent: "center", 
//                 alignItems: "center", p: 0.2, borderRadius: "50%" ,
//                    '&:hover': {
//       backgroundColor: "#003149", 
//     }}}>
//               <Add sx={{ color: "white" }} />
//             </IconButton>
//           </Box>

//           <Divider />


//           <Box sx={{ px: 1, py: 0.5 }}>
//             <Box sx={{ px: 0.5, mt: 0.5, py: 0.4, borderRadius: 1, height: 34, border: '2px solid #091E4224', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
//               {/* <InputBase placeholder="Search chats..." sx={{ ml: 0.5, fontSize: 15, letterSpacing: "1px", color: "#939393", fontWeight: 500 }} /> */}
//             <InputBase
//   placeholder={t("search_placeholder")}
//   value={searchTerm}
//   onChange={(e) => setSearchTerm(e.target.value)}
//   sx={{ ml: 0.5, fontSize: 15, letterSpacing: "1px", color: "#939393", fontWeight: 500 }}
// />
//               <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
//             </Box>
//           </Box>

        
//           <Box sx={{ flexGrow: 1, overflowY: 'auto',px:1, }}>
//             <List>
//          {filteredChats.map((chat, index) => (
// <ListItem
//   key={index}
//   button
//   selected={selectedChat.name === chat.name}
//   onClick={() => setSelectedChat(chat)}
//   sx={{ px: 1, position: 'relative' ,
//     borderRadius:2,
//         backgroundColor: selectedChat.name === chat.name ? '#006EC2' : 'transparent',
//     '&:hover': {
//       backgroundColor: selectedChat.name === chat.name ? '#006EC2' : '#f5f5f5',
//     }
//   }}
// >
//   <ListItemAvatar>
//     <Avatar src={chat.icon} />
//   </ListItemAvatar>
//   <ListItemText
//     primary={chat.name}
//     secondary={chat.msg}
//     primaryTypographyProps={{
//       fontWeight: '600',
//       fontSize: '14px',
//             color: selectedChat.name === chat.name ? '#fff' : '#100F0F',
//       fontFamily: 'Poppins, sans-serif',
//     }}
//     secondaryTypographyProps={{
//       fontSize: '13px',
//        color: selectedChat.name === chat.name ? '#E0E0E0' : '#5C5C5C',
//       fontFamily: 'Poppins, sans-serif',
//     }}
//   />
//   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
//     <Typography variant="body2" sx={{ ml: 0, 
//        color: selectedChat.name === chat.name ? '#fff' : '#100F0F',
//         fontSize: "13px", fontFamily: 'Poppins, sans-serif' }}>
//       {chat.time}
//     </Typography>
//     {chat.pinned && <img src={pinn} style={{ width: 20, height: 20 }} alt="pinned" />}
//   </Box>
// </ListItem>
                  
//               ))}
//             </List>
//           </Box>
//         </Box>

//         {/* <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}> */}
//  <Box
//   sx={{
//     flexGrow: 1,
//     width: { xs: '100%', md: 'auto' },
//     display: 'flex',
//     flexDirection: 'column',
//   }}
// >
//           <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//            <Avatar sx={{ mr: 2 }} src={selectedChat.icon} />
// <Typography sx={{  fontWeight: '600',
//       fontSize: '16px',
//       color: '#100F0F',
//       fontFamily: 'Poppins, sans-serif',}}>{selectedChat.name}</Typography>
//             </Box>
//             <IconButton><MoreVert /></IconButton>
//           </Box>


//           <Box sx={{ flexGrow: 1, px: 3, py: 2, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 1 }}>
//            <CustomText sx={{ ...textStyles.h1, fontSize:"40px", color: "#2C384C", textAlign: "center",pt:3, }}>
//          {t("feature_under_development")}
//               </CustomText>
//            <Box>
         
//             </Box>
//           </Box>

     
//           <Divider />
//           <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1 }}>
//             <IconButton sx={{color:"#44546F"}}><Add sx={{color:"#44546F"}}/></IconButton>
//             <img src={attachment} style={{width:20,height:20}}/>
//            <Box sx={{ position: 'relative', flexGrow: 1, mx: 2 }}>
//   <input
//     className="project_input"
//     placeholder={t("type_message_placeholder")}
//     style={{
//       width: '100%',
//       padding: '10px 40px 10px 12px',
//       fontSize: '15px',

//       fontFamily: 'Poppins, sans-serif',
//     }}
//   />
//   <IconButton
//     sx={{
//       position: 'absolute',
//       right: 6,
//       top: '50%',
//       transform: 'translateY(-50%)',
//       padding: 0,
//     }}
//   >
//    <img src={send}/>
//   </IconButton>
// </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Messages;